<div class="modal-header">
  <h3 class="modal-title">{{ 'payment-approval-new-from-report.add' | transloco }}</h3>
  <button class="close" type="button" (click)="dismissModal()">
    <span>×</span>
  </button>
</div>



<div class="modal-body" *ngIf="isLoading.form">
  <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

<div class="modal-body" *ngIf="!isLoading.form">
  <form class="m-form m-form--state m-form--label-align-right" [formGroup]="paymentApprovalForm"
        (ngSubmit)="onSubmitForm()">
    <div class="m-portlet__body" *ngIf="paymentApprovalForm">
      <div class="m-form__section m-form__section--first m-form--label-align-right">
        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.shop' | transloco }}:
          </label>
          <div class="col-lg-4 col-md-4 col-sm-12 m--margin-top-10">
            {{ data.storeTitle }}
          </div>
        </div>

        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.data' | transloco }}:
          </label>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <hx-date-select [formControlName]="invoiceFormKeys.date"></hx-date-select>
          </div>
        </div>

        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.supplier' | transloco }}:
          </label>

          <div class="col-lg-8 col-md-8 col-sm-12 m--margin-top-10">
            {{ data.supplierName }}
          </div>
        </div>

        <div class="form-group m-form__group row" *ngIf="paymentApprovalForm.controls.supplierId.value">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.bank' | transloco }}:
          </label>

          <div class="col-lg-8 col-md-8 col-sm-12">
            <hx-bank-account-select [supplierId]="paymentApprovalForm.controls.supplierId.value" [formControlName]="invoiceFormKeys.bankAccountId"></hx-bank-account-select>
          </div>
        </div>

        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.knp' | transloco }}:
          </label>

          <div class="col-lg-2 col-md-2 col-sm-12">
            <input type="text" [formControlName]="invoiceFormKeys.paymentDestinationCode"
                   class="form-control m-input" [placeholder]="'payment-approval-new-from-report.knp' | transloco" [title]="'payment-approval-new-from-report.knp' | transloco">
          </div>
        </div>

        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12">
            {{ 'payment-approval-new-from-report.note' | transloco }}:
          </label>

          <div class="col-lg-8 col-md-8 col-sm-12">
                      <textarea type="text" [formControlName]="invoiceFormKeys.note"
                                class="form-control m-input" [placeholder]="'payment-approval-new-from-report.note' | transloco " [title]="'payment-approval-new-from-report.note' | transloco ">
                      </textarea>
          </div>
        </div>

        <div class="m-form__section">
          <div class="form-group m-form__group m-form__group--colored row">
            <label class="col-form-label col-lg-3 col-sm-6">
              {{ 'payment-approval-new-from-report.overheads' | transloco }}:
            </label>

            <div class="col-lg-3 col-md-3 col-sm-6">
              <button (click)="addItem()" type="button" [disabled]="!paymentApprovalForm.controls.supplierId.value"
                      class="btn btn-success m-btn m-btn--icon m--margin-bottom-15">
                        <span>
                          <i class="la la-plus"></i>
                          <span>
                            {{ 'payment-approval-new-from-report.btn.add' | transloco }}
                          </span>
                        </span>
              </button>
              <span *ngIf="!paymentApprovalForm.controls.storeId.value">{{ 'payment-approval-new-from-report.noShop' | transloco }}</span>
            </div>
          </div>
          <div
            class="form-group m-form__group form-group m-form__group--colored m-form__group--last m-form__group--first"
            [formArrayName]="invoiceFormKeys.invoicePayments"
            *ngFor="let item of asFormArray(invoiceFormKeys.invoicePayments).controls; let ix = index;">
            <ng-container [formGroupName]="ix">
              <div class="row m--padding-bottom-15">
                <div class="col-lg-4 col-md-4 col-sm-3">
                  <small class="is--required">{{ 'payment-approval-new-from-report.overhead' | transloco }}:</small>
                  <hx-invoice-select [supplierId]="paymentApprovalForm.controls.supplierId.value"
                                     [storeId]="paymentApprovalForm.controls.storeId.value"
                                     [dueDateFrom]="data.dueDateFrom" [dueDateTo]="data.dueDateTo"
                                     [createDateFrom]="data.createDateFrom" [createDateTo]="data.createDateTo"
                                     [formControlName]="paymentApprovalFormKeys.invoiceId" (selectChange)="onInvoiceChnaged($event, ix)">
                  </hx-invoice-select>
                </div>

                <div class="col-lg-2 col-md-2">
                  <small>{{ 'payment-approval-new-from-report.totalSum' | transloco }}:</small>
                  <div>{{ storageInvoices[ix]?.totalPrice ?? 0 | uiCurrency:storageInvoices[ix]?.currency }}</div>
                </div>

                <div class="col-lg-2 col-md-2">
                  <small>{{ 'payment-approval-new-from-report.duty' | transloco }}:</small>
                  <div>{{ storageInvoices[ix]?.debtTotal  ?? 0 | uiCurrency:storageInvoices[ix]?.currency }}</div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-3">
                          <span class="d-inline-block" style="vertical-align: middle;">
                            <small class="is--required">{{ 'payment-approval-new-from-report.sumPaid' | transloco }}:</small>
                            <input type="text" [readOnly]="storageInvoices[ix]?.debtTotal === 0" [formControlName]="paymentApprovalFormKeys.value" (ngModelChange)="onValueChanged()"
                                   class="form-control m-input" [placeholder]="'payment-approval-new-from-report.sumPaid' | transloco" [title]="'payment-approval-new-from-report.sumPaid' | transloco">
                          </span>
                </div>

                <div class="col-lg-1 col-md-1">
                  <button (click)="removeItem(ix)" type="button" [ngbTooltip]="'payment-approval-new-from-report.deletePaid' | transloco"
                          class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill m--margin-top-25">
                    <i class="la la-trash"></i>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="form-group m-form__group row">
          <label class="col-form-label col-lg-3 col-sm-12 is--required">
            {{ 'payment-approval-new-from-report.totalSumPaid' | transloco }}:
          </label>

          <div class="col-lg-3 col-md-3 col-sm-12">
            <input type="text" [formControlName]="invoiceFormKeys.total" [readOnly]="asFormArray(invoiceFormKeys.invoicePayments).length > 0"
                   class="form-control m-input" [placeholder]="'payment-approval-new-from-report.totalSum' | transloco" [title]="'payment-approval-new-from-report.totalSum' | transloco">
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer modal-footer--pad-right">
      <button type="submit" class="btn btn-success">
        {{ 'btn.save' | transloco }}
      </button>

      <button type="button" (click)="dismissModal()" class="btn btn-secondary">
        {{ 'btn.cancel' | transloco }}
      </button>
    </div>
  </form>
</div>
